import { SummaryStateTypes, SummaryActionTypes } from "./Summary.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: SummaryStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const SummaryReducer = (
  state: SummaryStateTypes = INITIAL_STATE,
  action: any
): SummaryStateTypes => {
  switch (action.type) {
    case SummaryActionTypes.FETCH_ALL_SUMMARY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case SummaryActionTypes.FETCH_ALL_SUMMARY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SummaryActionTypes.FETCH_ALL_SUMMARY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SummaryActionTypes.FETCH_ALL_SUMMARY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case SummaryActionTypes.FETCH_ONE_SUMMARY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case SummaryActionTypes.FETCH_ONE_SUMMARY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SummaryActionTypes.FETCH_ONE_SUMMARY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SummaryActionTypes.FETCH_ONE_SUMMARY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default SummaryReducer;
